/**
 * IEP Supporting Documents API
 * Wraps /api/v1/materials/iep/* endpoints. Files are stored under
 *   material-repo/iep/{supervisor_user_id}/{child_id}/{section}/{filename}
 * on Azure File Share (with a local fallback in dev).
 */

import { get, del, upload } from './client';

/**
 * Upload a supporting document for a VB-MAPP section.
 * @param {Object} args
 * @param {string} args.childId - The child's ID (sharedData.childId)
 * @param {'milestones'|'barriers'} args.section
 * @param {File} args.file
 * @param {Function} [args.onProgress] - Progress callback (0-100)
 * @returns {Promise<{filename, path, size, url}>}
 */
export const uploadIepDocument = ({ childId, section, file, onProgress }) => {
  const formData = new FormData();
  formData.append('child_id', childId);
  formData.append('section', section);
  formData.append('file', file);
  return upload('/materials/iep/upload', formData, onProgress);
};

/**
 * List the calling supervisor's uploaded documents for a child.
 * @param {string} childId
 * @param {'milestones'|'barriers'} [section] - Filter to one section
 * @returns {Promise<{files: Array, total: number}>}
 */
export const listIepDocuments = (childId, section) => {
  const params = section ? { section } : {};
  return get(`/materials/iep/${encodeURIComponent(childId)}/list`, params);
};

/**
 * Delete a previously uploaded IEP document.
 * @param {string} path - The relative path returned by uploadIepDocument
 * @returns {Promise<{message: string}>}
 */
export const deleteIepDocument = (path) => del('/materials/iep/file', { path });

export default {
  uploadIepDocument,
  listIepDocuments,
  deleteIepDocument
};
